import { VehicleStatusesState } from "../types";

export const initialState: VehicleStatusesState = {
  loading: false,
  searchQuery: "",
  activeStatusTab: 0,
  activeDetailTab: 4,
  statCards: [],
  vehicles: [],
  selectedVehicleId: null,
  selectedVehicleDetail: null,
};
